module.exports = __webpack_public_path__ + "img/ANTENNA 4 LIME.b6ac0fe.svg";